module.exports = __webpack_public_path__ + "static/day-13b01f3804b026282c137bb3d832b89a.png";